/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestSignature_requestSignature_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string };

export type RequestSignature_Mutation = { readonly __typename: 'Mutation', readonly requestSignature: RequestSignature_requestSignature_CreditApplication };


export type RequestSignatureVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type RequestSignature = RequestSignature_Mutation;


export const RequestSignatureDocument = gql`
    mutation RequestSignature($creditApplicationId: ID!) {
  requestSignature(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
  }
}
    `;
export type RequestSignatureMutationFn = Apollo.MutationFunction<RequestSignature, RequestSignatureVariables>;

/**
 * __useRequestSignature__
 *
 * To run a mutation, you first call `useRequestSignature` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSignature` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSignature, { data, loading, error }] = useRequestSignature({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useRequestSignature(baseOptions?: Apollo.MutationHookOptions<RequestSignature, RequestSignatureVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestSignature, RequestSignatureVariables>(RequestSignatureDocument, options);
      }
export type RequestSignatureHookResult = ReturnType<typeof useRequestSignature>;
export type RequestSignatureMutationResult = Apollo.MutationResult<RequestSignature>;
export type RequestSignatureMutationOptions = Apollo.BaseMutationOptions<RequestSignature, RequestSignatureVariables>;